"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const IconNoIcon_1 = __importDefault(require("../icons/IconNoIcon"));
function getElementFromSource(src) {
    const svgContainer = document.createElement('div');
    svgContainer.innerHTML = src;
    const svg = svgContainer.firstElementChild;
    if (svg === null || svg === void 0 ? void 0 : svg.remove) {
        svg.remove();
    }
    else if (svg) {
        svgContainer.removeChild(svg);
    }
    svgContainer.remove();
    return svg;
}
function serializeAttrs(map) {
    const ret = {};
    if (!map) {
        return ret;
    }
    for (let prop, i = 0; i < map.length; i++) {
        const key = map[i].name;
        if (key === 'class') {
            prop = 'className';
        }
        else if (!key.startsWith('data-')) {
            prop = key.replace(/[-|:]([a-z])/g, g => g[1].toUpperCase());
        }
        else {
            prop = key;
        }
        ret[prop] = map[i].value;
    }
    return ret;
}
class Image extends react_1.Component {
    constructor(props) {
        var _a;
        super(props);
        this.state = {
            svg: !!((_a = this.props.src) === null || _a === void 0 ? void 0 : _a.startsWith('data:')),
            created: true,
            color: this.props.color || '',
            src: this.props.src || '',
            imgError: false,
            showError: !!this.props.showError,
        };
        this.svg = this.state.svg && this.state.src ? this.getSvgFromData(this.state.src) : null;
    }
    static getDerivedStateFromProps(props, state) {
        var _a;
        const newState = {};
        let changed = false;
        if (props && state && props.src !== state.src) {
            newState.src = props.src;
            newState.svg = (_a = props.src) === null || _a === void 0 ? void 0 : _a.startsWith('data:');
            newState.created = false;
            changed = true;
        }
        if (props && state && props.color !== state.color) {
            newState.color = props.color;
            newState.created = false;
            changed = true;
        }
        if (props && state && props.showError !== state.showError) {
            newState.showError = props.showError;
            changed = true;
        }
        return changed ? newState : null;
    }
    getSvgFromData(src) {
        const len = 'data:image/svg+xml;base64,';
        if (!src.startsWith(len)) {
            return null;
        }
        src = src.substring(len.length);
        try {
            src = atob(src);
            const svg = getElementFromSource(src);
            const inner = svg.innerHTML;
            const svgProps = serializeAttrs(svg.attributes);
            svg.remove();
            return react_1.default.createElement("svg", Object.assign({ className: this.props.className, style: this.state.color ? { color: this.state.color } : {} }, svgProps, { dangerouslySetInnerHTML: { __html: inner } }));
        }
        catch (e) {
            // ignore
        }
        return null;
    }
    render() {
        if (this.state.svg) {
            if (!this.state.created) {
                setTimeout(() => {
                    this.svg = this.state.src ? this.getSvgFromData(this.state.src) : null;
                    this.setState({ created: true });
                }, 50);
            }
            return this.svg;
        }
        if (this.state.src) {
            if (this.state.imgError || !this.state.src) {
                return react_1.default.createElement(IconNoIcon_1.default, { className: this.props.className });
            }
            return react_1.default.createElement("img", { className: this.props.className, src: (this.props.imagePrefix || '') + this.state.src, alt: "", onError: () => (this.props.showError ? this.setState({ imgError: true }) : this.setState({ src: '' })) });
        }
        return null;
    }
}
exports.default = Image;
